import React from "react";
import {Button} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";

const NotFound404 = () => {
    let history = useHistory();

    const { t } = useTranslation();
    document.title=404

    return (
        <div className="not-found">
            <h2>
                404
            </h2>
            <h4>
                {t("We couldn't find that page")}
            </h4>
            <p>
                {t("Looks like we couldn't find that page. Please try again or contact an administrator if the problem persists.")}
            </p>
                <Button className="btn-green" onClick={history.goBack}>
                    {t("Take me back")}
                </Button>
        </div>
    )
}

export default NotFound404